import { BrandTemplateAutofillDecodeResult } from './types';

type AutofillDecodeFailure = Extract<BrandTemplateAutofillDecodeResult, { ok: false }>;

// export const isReportableAutofillFailure = (
//   result: AutofillDecodeFailure,
// ): boolean => result.failure.code === 'invalid_variable';

export type AutofillFailureMessage = {
  title: string;
  variable: string;
  description: string;
};

export const toAutofillFailureMessage = (
  result: AutofillDecodeFailure,
): AutofillFailureMessage => {
  const { raw, failure } = result;

  switch (failure.code) {
    case 'invalid_variable':
      return {
        title: 'Variabile non valida',
        variable: raw,
        description: 'non è valida e non verrà compilata automaticamente.',
      };
    case 'unknown_entity':
      return {
        title: 'Variabile non riconosciuta',
        variable: raw,
        description: 'non corrisponde a nessuna fonte dati conosciuta.',
      };
    case 'no_transformer':
      return {
        title: 'Variabile non supportata',
        variable: raw,
        description: 'non è ancora supportata dalla compilazione automatica.',
      };
    default: {
      const exhaustive: never = failure;
      return exhaustive;
    }
  }
};
